webpackJsonp([1],{

/***/ "34KM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CkN4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ITjj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__("j1ja");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__("/5sW");

// EXTERNAL MODULE: ./src/common/stylus/index.styl
var stylus = __webpack_require__("34KM");
var stylus_default = /*#__PURE__*/__webpack_require__.n(stylus);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/header/header.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var header = ({
  props: {
    data: null
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0534bf7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/header.vue
var header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header",style:('color: ' + _vm.data.hex)},[_c('h1',{staticClass:"app-header-title",style:('color: ' + (_vm.data.isDepth ? '#fff' : '#000'))},[_vm._v("传统色彩"+_vm._s(_vm.data.name ? ('-' + _vm.data.name) : ''))]),_vm._v(" "),_c('span',{staticClass:"app-header-title-hex",style:('color: ' + (_vm.data.isDepth ? '#fff' : '#000'))},[_vm._v(_vm._s(_vm.data.hex))]),_vm._v(" "),_c('span',{staticClass:"app-header-title-rgb",style:('color: ' + (_vm.data.isDepth ? '#fff' : '#000'))},[_vm._v(_vm._s(_vm.data.rgb))])])}
var staticRenderFns = []
var esExports = { render: header_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var header_header = (esExports);
// CONCATENATED MODULE: ./src/components/header/header.vue
function injectStyle (ssrContext) {
  __webpack_require__("ITjj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  header,
  header_header,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_header_header = (Component.exports);

// CONCATENATED MODULE: ./src/common/js/util.js
/**
 *  根据RGB判断颜色深浅
 *  return false 浅色
 *  return true 深色
 **/
function colorDepthByRgb(color) {
  var rgb = color.replace(/\(?(:||rgb|RGB)*\)?/g, '').split(',');
  var r = parseInt(rgb[0]);
  var g = parseInt(rgb[1]);
  var b = parseInt(rgb[2]);
  var grayLevel = r * 0.299 + g * 0.587 + b * 0.114;
  return grayLevel <= 192;
}
/**
 * hex 转 rgb
 * return rgb
 **/
function hex2Rgb(color) {
  var _color = color.toLowerCase();
  var reg = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
  if (reg.test(_color)) {
    _color = _color.replace(/#/, '');
    if (_color.length === 3) {
      var tempHex = '';
      for (var i = 0; i < _color.length; i++) {
        tempHex += _color[i] + _color[i];
      }
      _color = tempHex;
    }
    var r = parseInt(_color.substring(0, 2), 16);
    var g = parseInt(_color.substring(2, 4), 16);
    var b = parseInt(_color.substring(4, 6), 16);
    return 'rgb(' + r + ', ' + g + ', ' + b + ')';
  }
  return null;
}
/**
 * rgb 转 cmyk
 * return [c, m, y, k]
 */
function rgb2Cmyk(color) {
  var rgb = color.replace(/(?:||rgb|RGB)*/g, '').split(',');
  var r = parseInt(rgb[0]);
  var g = parseInt(rgb[1]);
  var b = parseInt(rgb[2]);

  var computedC = 1 - r / 255;
  var computedM = 1 - g / 255;
  var computedY = 1 - b / 255;
  var minCMY = Math.min(computedC, Math.min(computedM, computedY));

  computedC = (computedC - minCMY) / (1 - minCMY);
  computedM = (computedM - minCMY) / (1 - minCMY);
  computedY = (computedY - minCMY) / (1 - minCMY);
  var computedK = minCMY;

  return [computedC, computedM, computedY, computedK];
}
/**
  * 复制
  */
function copy(value, callback) {
  var copyTextArea = null;
  try {
    copyTextArea = document.createElement('textarea');
    copyTextArea.style.height = '0px';
    copyTextArea.style.width = '0px';
    copyTextArea.style.opacity = '0';
    document.body.appendChild(copyTextArea);
    copyTextArea.value = value;
    copyTextArea.select();
    document.execCommand('copy');
    callback && callback();
  } finally {
    if (copyTextArea && copyTextArea.parentNode) {
      copyTextArea.parentNode.removeChild(copyTextArea);
    }
  }
}

/**
  * 内核判断
  *
  */
var deviceCore = {
  _ua: navigator.userAgent.toLowerCase(),
  // 获取浏览器版本
  _getVersion: function _getVersion(nece) {
    var arr = nece.split('.');
    return parseFloat(arr[0] + '.' + arr[1]);
  },
  // 设备检测
  _detect: function _detect(kernel) {
    var reg = new RegExp(kernel, 'img');
    return reg.test(deviceCore._ua);
  }
};
var device = {
  isIOS: function isIOS() {
    return deviceCore._detect('iPhone|iPad|iPod|iOS|mac os');
  },
  isAndroid: function isAndroid() {
    return deviceCore._detect('Android');
  },
  isUCBrowser: function isUCBrowser() {
    return deviceCore._detect('UCBrowser');
  },
  isQQBrowser: function isQQBrowser() {
    return deviceCore._detect('QQBrowser');
  },
  isWeixin: function isWeixin() {
    return deviceCore._detect('MicroMessenger');
  },
  isPC: function isPC() {
    return !deviceCore._detect('phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone');
  },
  qqBrowserVersion: function qqBrowserVersion() {
    return device.isQQBrowser() ? deviceCore._getVersion(deviceCore._ua.split('mqqbrowser/')[1]) : 0;
  },
  ucBrowserVersion: function ucBrowserVersion() {
    return device.isUCBrowser() ? deviceCore._getVersion(deviceCore._ua.split('ucbrowser/')[1]) : 0;
  },
  iOSVersion: function iOSVersion() {
    return device.isIOS() ? parseInt(deviceCore._ua.match(/\s*os\s*\d+/gi)[0].split(' ')[2], 10) : 0;
  }
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/card/card.vue
//
//
//
//
//
//
//


/* harmony default export */ var card = ({
  data: function data() {
    return {
      copied: false
    };
  },

  props: {
    data: null,
    index: 0,
    type: 0
  },
  methods: {
    changeColor: function changeColor(type, index) {
      var _this = this;

      this.$emit('click', type, index);
      if (device.isPC()) {
        copy(this.data.hex, function () {
          _this.copied = true;
          console.log('复制成功');
          setTimeout(function () {
            _this.copied = false;
          }, 1000);
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01f699da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/card/card.vue
var card_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-main-item",class:{'copied': _vm.copied},style:('background-color: ' + _vm.data.hex + ';border-color: ' + _vm.data.hex + ';color: ' + (_vm.data.isDepth ? '#fff' : '#000')),on:{"click":function($event){_vm.changeColor(_vm.type, _vm.index)}}},[_c('p',{staticClass:"app-main-item-name"},[_vm._v("【"+_vm._s(_vm.data.name)+"】")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.data.hex))])])}
var card_staticRenderFns = []
var card_esExports = { render: card_render, staticRenderFns: card_staticRenderFns }
/* harmony default export */ var card_card = (card_esExports);
// CONCATENATED MODULE: ./src/components/card/card.vue
function card_injectStyle (ssrContext) {
  __webpack_require__("CkN4")
}
var card_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var card___vue_template_functional__ = false
/* styles */
var card___vue_styles__ = card_injectStyle
/* scopeId */
var card___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var card___vue_module_identifier__ = null
var card_Component = card_normalizeComponent(
  card,
  card_card,
  card___vue_template_functional__,
  card___vue_styles__,
  card___vue_scopeId__,
  card___vue_module_identifier__
)

/* harmony default export */ var components_card_card = (card_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/footer/footer.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var footer = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c81e1278","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/footer.vue
var footer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('a',{attrs:{"href":"https://gabrielwenfu.github.io/cfs-color/","target":"_blank"}},[_c('svg',{staticClass:"icon",staticStyle:{"width":"50px","height":"50px"}},[_c('use',{attrs:{"xlink:href":"static/icon.svg#github"}})])])])}
var footer_staticRenderFns = []
var footer_esExports = { render: footer_render, staticRenderFns: footer_staticRenderFns }
/* harmony default export */ var footer_footer = (footer_esExports);
// CONCATENATED MODULE: ./src/components/footer/footer.vue
function footer_injectStyle (ssrContext) {
  __webpack_require__("opdc")
}
var footer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var footer___vue_template_functional__ = false
/* styles */
var footer___vue_styles__ = footer_injectStyle
/* scopeId */
var footer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var footer___vue_module_identifier__ = null
var footer_Component = footer_normalizeComponent(
  footer,
  footer_footer,
  footer___vue_template_functional__,
  footer___vue_styles__,
  footer___vue_scopeId__,
  footer___vue_module_identifier__
)

/* harmony default export */ var components_footer_footer = (footer_Component.exports);

// CONCATENATED MODULE: ./src/common/js/data.js
var data_data = [{
  title: '中国色颜色色谱',
  list: [{ name: '百草霜', hex: '#303030' }, { name: '柏坊灰蓝', hex: '#4e1892' }, { name: '宝蓝', hex: '#1f3696' }, { name: '北京毛蓝', hex: '#276893' }, { name: '碧玉石', hex: '#569597' }, { name: '苍黄', hex: '#c65306' }, { name: '藏蓝', hex: '#25386b' }, { name: '苍绿', hex: '#4e5f45' }, { name: '草黄', hex: '#dbce54' }, { name: '承德灰', hex: '#757570' }, { name: '承德皂', hex: '#5a5c5b' }, { name: '辰砂', hex: '#af5e53' }, { name: '春蓝', hex: '#7ba1a8' }, { name: '春绿', hex: '#e3efd1' }, { name: '翠绿', hex: '#006e5f' }, { name: '粗晶皂', hex: '#43454a' }, { name: '大赤金', hex: '#6d7358' }, { name: '黛蓝', hex: '#304758' }, { name: '丹东石', hex: '#d7c16b' }, { name: '淡灰绿', hex: '#aec4b7' }, { name: '灯草灰', hex: '#363532' }, { name: '靛蓝', hex: '#1b54f2' }, { name: '蕃茄红', hex: '#c4473d' }, { name: '妃红', hex: '#c35655' }, { name: '甘草黄', hex: '#e4cf8e' }, { name: '橄榄绿', hex: '#6a6834' }, { name: '甘石粉', hex: '#eadcd6' }, { name: '钴蓝', hex: '#6493af' }, { name: '果灰', hex: '#88aea3' }, { name: '海蓝', hex: '#17507d' }, { name: '红皂', hex: '#4f5355' }, { name: '黄灰', hex: '#b0b7ac' }, { name: '花青', hex: '#546b83' }, { name: '胡粉', hex: '#ebe8db' }, { name: '灰蓝', hex: '#5d828a' }, { name: '灰绿', hex: '#5c8987' }, { name: '灰米', hex: '#b6b196' }, { name: '姜黄', hex: '#b49436' }, { name: '将校呢', hex: '#6d614a' }, { name: '绛紫', hex: '#704d4e' }, { name: '桔红', hex: '#e7693f' }, { name: '桔黄', hex: '#e8853b' }, { name: '金黄', hex: '#c77a3a' }, { name: '军绿', hex: '#cad4ba' }, { name: '孔雀蓝', hex: '#0041a5' }, { name: '库金', hex: '#85794f' }, { name: '枯绿', hex: '#b7b278' }, { name: '蜡白', hex: '#e7e5d0' }, { name: '老绿', hex: '#3d6e53' }, { name: '榴花红', hex: '#d54b44' }, { name: '芦灰', hex: '#a9b08f' }, { name: '玫瑰红', hex: '#973444' }, { name: '玫瑰灰', hex: '#793d56' }, { name: '米红', hex: '#e1bda2' }, { name: '米灰', hex: '#c5bfad' }, { name: '米色', hex: '#f5f5dc' }, { name: '奶绿', hex: '#afc8ba' }, { name: '奶棕', hex: '#c1a299' }, { name: '柠檬黄', hex: '#e9db39' }, { name: '品红', hex: '#a71368' }, { name: '浅海昌蓝', hex: '#3c5e91' }, { name: '浅黄棕', hex: '#dea87a' }, { name: '浅桔黄', hex: '#da9558' }, { name: '牵牛紫', hex: '#a22076' }, { name: '浅石英紫', hex: '#ab96c5' }, { name: '浅藤紫', hex: '#c4c3cb' }, { name: '浅驼色', hex: '#c9ae8c' }, { name: '浅血牙', hex: '#eacdd1' }, { name: '浅棕灰', hex: '#e1dbcd' }, { name: '卡其黄', hex: '#d5b884' }, { name: '卡其绿', hex: '#647370' }, { name: '茄皮紫', hex: '#674950' }, { name: '鹊灰', hex: '#455667' }, { name: '绒蓝', hex: '#31678d' }, { name: '三绿', hex: '#90caaf' }, { name: '沙绿', hex: '#005b5a' }, { name: '沙青', hex: '#2b5e7d' }, { name: '深烟', hex: '#5a4c4c' }, { name: '深烟红', hex: '#643441' }, { name: '深竹月', hex: '#2578b5' }, { name: '十样锦', hex: '#fcb1aa' }, { name: '水貂灰', hex: '#949c97' }, { name: '水黄', hex: '#bed2b6' }, { name: '藤黄', hex: '#f2de76' }, { name: '天青色', hex: '#2ec3e7' }, { name: '铁灰', hex: '#37444b' }, { name: '土黄', hex: '#ce9335' }, { name: '相思灰', hex: '#625c52' }, { name: '血红', hex: '#a03e28' }, { name: '猩红', hex: '#c43739' }, { name: '雄黄', hex: '#d0853d' }, { name: '雄精', hex: '#e47542' }, { name: '锈红', hex: '#4d1919' }, { name: '锈绿', hex: '#b8c8b7' }, { name: '选金', hex: '#796f54' }, { name: '雪色', hex: '#fffafa' }, { name: '雪紫', hex: '#79485a' }, { name: '鸭蛋青', hex: '#d1e3db' }, { name: '洋葱紫', hex: '#9c6680' }, { name: '洋红', hex: '#dc143c' }, { name: '艳红', hex: '#cc3536' }, { name: '鹦鹉绿', hex: '#008e59' }, { name: '银朱', hex: '#dd3b44' }, { name: '油绿', hex: '#45554a' }, { name: '油烟墨', hex: '#3f3f3c' }, { name: '元青', hex: '#3e3c3d' }, { name: '胭脂', hex: '#c03f3c' }, { name: '银箔', hex: '#585a57' }, { name: '月季红', hex: '#bb1c33' }, { name: '玉石蓝', hex: '#507883' }, { name: '枣红', hex: '#89303f' }, { name: '章丹', hex: '#eb652d' }, { name: '正灰', hex: '#93a2a9' }, { name: '枝黄', hex: '#dbc7a6' }, { name: '织锦灰', hex: '#748a8d' }, { name: '纸棕', hex: '#bca590' }, { name: '中棕灰', hex: '#a9987c' }, { name: '紫粉', hex: '#a54358' }, { name: '紫水晶', hex: '#c3a6cb' }, { name: '紫藤灰', hex: '#857e95' }, { name: '紫薇花', hex: '#eea5d1' }, { name: '棕茶', hex: '#b8844f' }]
}, {
  title: '中国传统色彩标准色卡',
  list: [{ name: '精白', hex: '#ffffff' }, { name: '银白', hex: '#e9e7ef' }, { name: '铅白', hex: '#f0f0f4' }, { name: '霜色', hex: '#e9f1f6' }, { name: '雪白', hex: '#f0fcff' }, { name: '莹白', hex: '#e3f9fd' }, { name: '月白', hex: '#d6ecf0' }, { name: '象牙白', hex: '#fffbf0' }, { name: '缟', hex: '#f2ecde' }, { name: '鱼肚白', hex: '#fcefe8' }, { name: '白粉', hex: '#fff2fd' }, { name: '茶白', hex: '#f3f9f1' }, { name: '鸭卵青', hex: '#e0eee8' }, { name: '素', hex: '#e0f0e9' }, { name: '青白', hex: '#c0ebd7' }, { name: '蟹壳青', hex: '#bbcdc5' }, { name: '花白', hex: '#c2ccd0' }, { name: '老银', hex: '#bacac6' }, { name: '灰色', hex: '#808080' }, { name: '苍色', hex: '#75878a' }, { name: '水色', hex: '#88ada6' }, { name: '黝', hex: '#6b6882' }, { name: '乌色', hex: '#725e82' }, { name: '玄青', hex: '#3d3b4f' }, { name: '乌黑', hex: '#392f41' }, { name: '黎', hex: '#75664d' }, { name: '黧', hex: '#5d513c' }, { name: '黝黑', hex: '#665757' }, { name: '缁色', hex: '#493131' }, { name: '煤黑', hex: '#312520' }, { name: '漆黑', hex: '#161823' }, { name: '黑色', hex: '#000000' }, { name: '樱草色', hex: '#eaff56' }, { name: '鹅黄', hex: '#fff143' }, { name: '鸭黄', hex: '#faff72' }, { name: '杏黄', hex: '#ffa631' }, { name: '橙黄', hex: '#ffa400' }, { name: '橙色', hex: '#fa8c35' }, { name: '杏红', hex: '#ff8c31' }, { name: '橘黄', hex: '#ff8936' }, { name: '橘红', hex: '#ff7500' }, { name: '藤黄', hex: '#ffb61e' }, { name: '姜黄', hex: '#ffc773' }, { name: '雌黄', hex: '#ffc64b' }, { name: '赤金', hex: '#f2be45' }, { name: '缃色', hex: '#f0c239' }, { name: '雄黄', hex: '#e9bb1d' }, { name: '秋香色', hex: '#d9b611' }, { name: '金色', hex: '#eacd76' }, { name: '牙色', hex: '#eedeb0' }, { name: '枯黄', hex: '#d3b17d' }, { name: '黄栌', hex: '#e29c45' }, { name: '乌金', hex: '#a78e44' }, { name: '昏黄', hex: '#c89b40' }, { name: '棕黄', hex: '#ae7000' }, { name: '琥珀', hex: '#ca6924' }, { name: '棕色', hex: '#b25d25' }, { name: '茶色', hex: '#b35c44' }, { name: '棕红', hex: '#9b4400' }, { name: '赭', hex: '#9c5333' }, { name: '驼色', hex: '#a88462' }, { name: '秋色', hex: '#896c39' }, { name: '棕绿', hex: '#827100' }, { name: '褐色', hex: '#6e511e' }, { name: '棕黑', hex: '#7c4b00' }, { name: '赭色', hex: '#955539' }, { name: '赭石', hex: '#845a33' }, { name: '松花色', hex: '#bce672' }, { name: '柳黄', hex: '#c9dd22' }, { name: '嫩绿', hex: '#bddd22' }, { name: '柳绿', hex: '#afdd22' }, { name: '葱黄', hex: '#a3d900' }, { name: '葱绿', hex: '#9ed900' }, { name: '豆绿', hex: '#9ed048' }, { name: '豆青', hex: '#96ce54' }, { name: '油绿', hex: '#00bc12' }, { name: '葱青', hex: '#0eb83a' }, { name: '青葱', hex: '#0aa344' }, { name: '石绿', hex: '#16a951' }, { name: '松柏绿', hex: '#21a675' }, { name: '松花绿', hex: '#057748' }, { name: '绿沈', hex: '#0c8918' }, { name: '绿色', hex: '#00e500' }, { name: '草绿', hex: '#40de5a' }, { name: '青翠', hex: '#00e079' }, { name: '青色', hex: '#00e09e' }, { name: '翡翠绿', hex: '#3de1ad' }, { name: '碧绿', hex: '#2add9c' }, { name: '玉色', hex: '#2edfa3' }, { name: '缥', hex: '#7fecad' }, { name: '艾绿', hex: '#a4e2c6' }, { name: '石绿', hex: '#7bcfa6' }, { name: '碧色', hex: '#1bd1a5' }, { name: '青碧', hex: '#48c0a3' }, { name: '铜绿', hex: '#549688' }, { name: '竹青', hex: '#789262' }, { name: '墨灰', hex: '#758a99' }, { name: '墨色', hex: '#50616d' }, { name: '鸦青', hex: '#424c50' }, { name: '黯', hex: '#41555d' }, { name: '朱砂', hex: '#ff461f' }, { name: '火红', hex: '#ff2d51' }, { name: '朱磦', hex: '#f36838' }, { name: '妃色', hex: '#ed5736' }, { name: '洋粉', hex: '#ff4777' }, { name: '品红', hex: '#f00056' }, { name: '粉红', hex: '#ffb3a7' }, { name: '桃红', hex: '#f47983' }, { name: '海棠红', hex: '#db5a6b' }, { name: '樱桃色', hex: '#c93756' }, { name: '酡颜', hex: '#f9906f' }, { name: '银红', hex: '#f05654' }, { name: '大红', hex: '#ff2121' }, { name: '石榴红', hex: '#f20c00' }, { name: '绛紫', hex: '#8c4356' }, { name: '绯红', hex: '#c83c23' }, { name: '朱红', hex: '#ff4c00' }, { name: '丹', hex: '#ff4e20' }, { name: '彤', hex: '#f35336' }, { name: '酡红', hex: '#dc3023' }, { name: '炎', hex: '#ff3300' }, { name: '茜色', hex: '#cb3a56' }, { name: '绾', hex: '#a98175' }, { name: '檀', hex: '#b36d61' }, { name: '嫣红', hex: '#ef7a82' }, { name: '洋红', hex: '#ff0097' }, { name: '枣红', hex: '#c32136' }, { name: '殷红', hex: '#be0027' }, { name: '赫赤', hex: '#c91f37' }, { name: '银朱', hex: '#bf242a' }, { name: '赤', hex: '#c3272b' }, { name: '胭脂', hex: '#9d2933' }, { name: '栗色', hex: '#60281e' }, { name: '玄色', hex: '#622a1d' }, { name: '蔚蓝', hex: '#70f3ff' }, { name: '蓝', hex: '#44cef6' }, { name: '碧蓝', hex: '#3eede7' }, { name: '石青', hex: '#1685a9' }, { name: '靛青', hex: '#177cb0' }, { name: '靛蓝', hex: '#065279' }, { name: '花青', hex: '#003472' }, { name: '宝蓝', hex: '#4b5cc4' }, { name: '蓝灰色', hex: '#a1afc9' }, { name: '藏青', hex: '#2e4e7e' }, { name: '藏蓝', hex: '#3b2e7e' }, { name: '黛', hex: '#4a4266' }, { name: '黛绿', hex: '#426666' }, { name: '黛蓝', hex: '#425066' }, { name: '黛紫', hex: '#574266' }, { name: '紫色', hex: '#8d4bbb' }, { name: '紫酱', hex: '#815463' }, { name: '酱紫', hex: '#815476' }, { name: '紫檀', hex: '#4c221b' }, { name: '绀青', hex: '#003371' }, { name: '紫棠', hex: '#56004f' }, { name: '青莲', hex: '#801dae' }, { name: '群青', hex: '#4c8dae' }, { name: '雪青', hex: '#b0a4e3' }, { name: '丁香色', hex: '#cca4e3' }, { name: '藕色', hex: '#edd1d8' }, { name: '藕合色', hex: '#e4c6d0' }]
}];

/* harmony default export */ var js_data = (data_data);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var App = ({
  components: {
    CfsHeader: components_header_header,
    CfsCard: components_card_card,
    CfsFooter: components_footer_footer
  },
  data: function data() {
    return {
      data: js_data || [],
      currData: null,
      copied: false
    };
  },
  created: function created() {
    this._initData();
  },

  methods: {
    _initData: function _initData() {
      var _data = this.data;
      _data.map(function (_items) {
        _items.list.map(function (_item) {
          _item.rgb = hex2Rgb(_item.hex);
          _item.isDepth = colorDepthByRgb(_item.rgb);
          return _item;
        });
        return _items;
      });
      var _currList = _data[Math.floor(Math.random() * _data.length)].list || [];
      this.currData = _currList[Math.floor(Math.random() * _currList.length)];
      this.data = _data;
    },
    changeColor: function changeColor(type, index) {
      this.currData = this.data[type].list[index];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0172bc5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('cfs-header',{attrs:{"data":_vm.currData}}),_vm._v(" "),_c('section',{staticClass:"list-container"},[_c('div',{staticClass:"app-main"},_vm._l((_vm.data),function(items,type){return _c('div',{key:type,staticClass:"app-main-items"},[_c('div',{staticClass:"app-main-items-head"},[_c('div',{staticClass:"app-main-items-head-title"},[_vm._v(_vm._s(items.title))])]),_vm._v(" "),_c('div',{staticClass:"app-main-items-body"},_vm._l((items.list),function(item,index){return _c('div',{key:index,staticClass:"app-main-items-card"},[_c('cfs-card',{attrs:{"data":item,"index":index,"type":type},on:{"click":_vm.changeColor}})],1)}))])}))]),_vm._v(" "),_c('cfs-footer')],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("sSVf")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/main.js






vue_runtime_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_runtime_esm["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(src_App);
  }
});

/***/ }),

/***/ "opdc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sSVf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.f0044e429b8e656acdf6.js